module.exports = __webpack_public_path__ + "static/media/hot03.4aff6efd.jpg";